import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API_URL from "./creds"

const TranslationViewer = () => {
  const { id } = useParams();
  const translatedId = id || "1001";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedLang, setSelectedLang] = useState("eng");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_URL}/${translatedId}`);
        const result = await response.json();
        setData(result);
        console.log("translated:", data)
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, []);

  if (loading) {
    return <p className="text-center">Loading...</p>;
  }

  if (!data || data.status !== "Success") {
    return <p className="text-center">Error: Could not fetch data</p>;
  }

  const selectedTranslation = data.translations.find(
    (translation) => translation.lang === selectedLang
  );

  return (
    <div className="container mx-auto p-4">
      <div className="text-center">
        <img
          src={data.img_url}
          alt={data.img_alt}
          className="w-full max-w-md mx-auto rounded-lg mb-4"
        />
      </div>
      <div className="flex flex-col items-center md:flex-row md:justify-end mb-4">
        <select
          value={selectedLang}
          onChange={(e) => setSelectedLang(e.target.value)}
          className="p-2 border rounded"
        >
          {data.translations.map((translation) => (
            <option key={translation.lang} value={translation.lang}>
              {translation.lang_display}
            </option>
          ))}
        </select>
      </div>
      <div className="p-4 border rounded shadow-lg bg-gray-50 max-w-4xl mx-auto w-full mb-4">
        {selectedTranslation ? (
          <div
            dangerouslySetInnerHTML={{ __html: selectedTranslation.text }}
            className="text-lg"
          ></div>
        ) : (
          <p>No translation available for the selected language.</p>
        )}
      </div>

    </div>
  );
};

export default TranslationViewer;

